import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataStock } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_STOCK = defineMasterdataEntity<MasterdataStock>({
  name: 'stock',
  responseKey: 'stocks',
  displayWith: (s) => keyName(s.key, s.name),
  secondaryWith: (s) => s.name2,
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-warehouse',
  title: 'Lagersuche',
  label: 'Lager',
  placeholder: 'Lager suchen...',
  columns: [
    {
      label: 'Lager',
      type: 'entity',
      icon: 'fa-regular fa-warehouse',
      value: (s) => keyName(s.key, s.name),
      secondary: (s) => s.name2,
    },
    { label: 'Schlüssel', value: (s) => s.key },
    { label: 'Bezeichnung', value: (s) => s.name },
    { label: 'Bezeichnung 2', value: (s) => s.name2 },
    { label: 'Bezeichnung 3', value: (s) => s.name3 },
    { label: 'Aktiv', value: (s) => (s.active ? 'Ja' : 'Nein') },
    { label: 'Art', value: (s) => s.type?.name ?? null },
    { label: 'Lagerverwaltungssystem', value: (s) => s.wcs?.name ?? null },
    { label: 'Erstbestandsdatum', value: (s) => s.initialStockDate },
  ],
});
